import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { ScrollText, MessageSquareLock } from "lucide-react";

const AKSI_TONE = { tambah: "bg-emerald-100 text-emerald-800 dark:text-emerald-300", edit: "bg-blue-100 text-blue-800", hapus: "bg-rose-100 text-rose-800", impor: "bg-teal-100 text-teal-800", login: "bg-slate-100 text-slate-600 dark:text-slate-300", login_otp: "bg-slate-100 text-slate-600 dark:text-slate-300", reset_sandi: "bg-amber-100 text-amber-800", ubah_sandi: "bg-amber-100 text-amber-800" };

export function AuditLog() {
  const { data: rows = [] } = useQuery({ queryKey: ["audit"], queryFn: async () => (await api.get("/audit-log?limit=150")).data, refetchInterval: 15000 });
  return (
    <div className="glass rounded-2xl p-6 space-y-4" data-testid="audit-log">
      <div className="flex items-center gap-2 text-emerald-800 dark:text-emerald-300"><ScrollText className="h-5 w-5" /><span className="font-bold text-lg">Audit Log Aktivitas Pengurus</span></div>
      <div className="max-h-[420px] overflow-y-auto space-y-1.5 pr-1">
        {rows.map((r) => (
          <div key={r.id} className="flex items-start gap-3 bg-white/60 dark:bg-white/5 rounded-xl px-3 py-2 text-sm" data-testid={`audit-row-${r.id}`}>
            <Badge className={`border-0 text-[10px] shrink-0 mt-0.5 ${AKSI_TONE[r.aksi] || "bg-slate-100 text-slate-600 dark:text-slate-300"}`}>{r.aksi}</Badge>
            <div className="min-w-0 flex-1">
              <p className="text-emerald-950 dark:text-emerald-50"><strong>{r.oleh}</strong> <span className="text-slate-500 dark:text-slate-300">({r.role})</span> → <span className="font-medium">{r.target}</span></p>
              {r.detail && Object.keys(r.detail).length > 0 && <p className="text-xs text-slate-500 dark:text-slate-300 truncate">{JSON.stringify(r.detail)}</p>}
            </div>
            <span className="text-xs text-slate-400 shrink-0">{new Date(r.created_at).toLocaleString("id-ID")}</span>
          </div>
        ))}
        {rows.length === 0 && <p className="text-center text-slate-400 text-sm py-6">Belum ada aktivitas tercatat.</p>}
      </div>
    </div>
  );
}

export function OtpLog() {
  const { data } = useQuery({ queryKey: ["otp-log"], queryFn: async () => (await api.get("/otp-log")).data, refetchInterval: 10000 });
  if (!data) return null;
  return (
    <div className="glass rounded-2xl p-6 space-y-3" data-testid="otp-log">
      <div className="flex items-center gap-2 text-emerald-800 dark:text-emerald-300"><MessageSquareLock className="h-5 w-5" /><span className="font-bold text-lg">Gateway WhatsApp (OTP)</span></div>
      {data.simulation ? (
        <div className="text-sm bg-amber-50 border border-amber-200 text-amber-900 rounded-xl p-3" data-testid="otp-simulation-banner">
          <strong>MODE SIMULASI aktif</strong> — token Fonnte (<code>FONNTE_TOKEN</code>) belum diisi di server. Kode OTP tidak dikirim ke WA, tetapi dicatat di sini agar Super Admin dapat membantu wali/pengurus masuk.
        </div>
      ) : <p className="text-sm text-emerald-700 dark:text-emerald-400">Terhubung ke Fonnte. OTP dikirim via WhatsApp.</p>}
      <div className="max-h-56 overflow-y-auto space-y-1">
        {data.items.map((o) => (
          <div key={o.id} className="flex items-center justify-between text-xs bg-white/60 dark:bg-white/5 rounded-lg px-3 py-1.5">
            <span className="text-slate-600 dark:text-slate-300">{o.purpose} · {o.phone}</span>
            {o.code && <span className="font-mono font-bold text-emerald-800 dark:text-emerald-300 tracking-widest" data-testid="otp-log-code">{o.code}</span>}
            <span className="text-slate-400">{new Date(o.created_at).toLocaleTimeString("id-ID")}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
